import {post} from "../../../../../controlers/global/ConfigRequest";
import {useContext, useState} from "react";
import {SHARE_SOCIAL_MEDIA} from "../../../../../helperData/ApiAddress";
import { publicContentShareUrl } from "../../../../../features/content-studio/api";

import {ReactComponent as CopyIcon} from "./../../../../../asset/icons/copyIconBlue.svg";
import DBButton from "../../../../../component/global/DBButton";
import {ToastContext} from "../../../../../component/global/ToastContext";
import {useTranslation} from "react-i18next";

export default function SocialShare({content}) {
  const show = useContext(ToastContext);
  const [link, setLink] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const {t} = useTranslation();

  const createLinkHandle = () => {
    setLoading(true);
    post(SHARE_SOCIAL_MEDIA, {
      content,
      description,
    }).then((r) => {
      setLoading(false);
      setLink(publicContentShareUrl(r.code));
    });
  };

  const copyToClipboard = (val) => {
    var copyText = document.createElement("INPUT");
    copyText.type = "text";
    copyText.value = val;

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    navigator.clipboard.writeText(copyText.value);
    show(
      t(
        "Src.Pages.CustomerClub.Components.ContentManagment.SocialShare.success"
      ),
      "success"
    );
  };

  return (
    <div className="share-social-media">
      <label>
        {t(
          "Src.Pages.CustomerClub.Components.ContentManagment.SocialShare.Label"
        )}
      </label>
      <p className="share-reward-hint">
        {t(
          "Src.Pages.CustomerClub.Components.ContentManagment.SocialShare.Hint"
        )}
      </p>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      ></textarea>
      <div className="btn-group">
        <DBButton
          caption={t(
            "Src.Pages.CustomerClub.Components.ContentManagment.SocialShare.Button"
          )}
          loading={loading}
          onClick={createLinkHandle}
        />
      </div>
      {link && (
        <>
          <label>
            {t(
              "Src.Pages.CustomerClub.Components.ContentManagment.SocialShare.Link.Label"
            )}
          </label>
          <div className="share-link">
            <input type="text" readOnly value={link}/>
            <button onClick={() => copyToClipboard(link)}>
              <CopyIcon/>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
